// Font awesome icons
/*eslint-disable */
import {
  faAddressBook,
  faBell,
  faBuilding,
  faBullhorn,
  faCodeBranch,
  faCogs,
  faEdit,

  faEnvelope,
  faFileMedicalAlt,
  faFileUpload,
  faFingerprint,
  faFirstAid,
  faHardHat,
  faHeartbeat,
  faHeartBroken,
  faHourglassStart,
  faImage,
  faLanguage,
  faLaptopMedical,
  faLeaf,
  faList,
  faListOl,
  faMobileAlt,
  faPhone,
  faPlus,
  faQrcode,
  faSlidersH,
  // faSolarPanel,
  faStopwatch20,
  faTachometerAlt,
  faTools,
  faUmbrellaBeach,
  faUpload,
  faUser,
  faUserCircle,
  faUserClock,
  faUserCog,
  faUserMd,
  faUserNurse,
  faUsers,
  faUserShield,
  faUserTag,
  faUserTie,
  faVolumeUp,
  faMapMarkerAlt,
  faMapPin,
  faClipboardCheck,
  faHome,
  faPhoneSquare,
  faSolarPanel,
  faMicrophoneAlt,
  faPenNib,
  faFileInvoice,
  faFileExcel,
  faFileAudio,
  faAudioDescription,
} from "@fortawesome/free-solid-svg-icons";

import UserProfile from "views/User/UserProfile";
import Admin from "layouts/Admin";
import Role from "views/UserManagement/Role/RoleList";
import PendingWorkerList from "views/Worker/PendingApprovalList";
import RoleForm from "views/UserManagement/Role/RoleForm";
import RoleEditForm from "views/UserManagement/Role/RoleEditForm";
import BackOfficeUserForm from "views/User/BackOfficeUserForm";
import BackOfficeUserEditForm from "views/User/BackOfficeUserEditForm";
import BackOfficeUserList from "views/User/BackOfficeUserList";
import WorkerList from "views/Worker/WorkerList";
import WorkerCreateForm from "views/Worker/WorkerCreateForm";
import WorkerEditForm from "views/Worker/WorkerEditForm";

import SupervisorAssignmentForm from "views/SupervisorAssignment/SupervisorAssignmentForm";
import SupervisorAssignmentList from "views/SupervisorAssignment/SupervisorAssignmentList";
import SupervisorBulkAssignment from "views/SupervisorAssignment/SupervisorBulkAssignment";

import Banner from "views/Announcement/BannerList";
import BannerForm from "views/Announcement/BannerForm";
import BannerCountConfig from "views/Announcement/BannerCountConfig";

import {
  ITEM_URL,
  MAIN_URL,
  MODULES,
  PAGE_NAME,
  SUB_ITEM_URL,
} from "configs/constants";
import AttendanceSummary from "views/Attendance/AttendanceSummary";
import AttendanceRecord from "views/Attendance/AttendanceRecord";
import AttendanceRecordByMonth from "views/Attendance/AttendanceRecordByMonth";

import AttendanceForm from "views/Attendance/AttendanceForm";

import GrievanceList from "views/Grievance/GrievanceList";
import GrievanceEditForm from "views/Grievance/GrievanceEditForm";
import AttendanceMethod from "views/Attendance/AttendanceMethod";
import AppFeatureControlList from "views/AppFeatureControl/AppFeatureControlList";
import AppFeatureControlForm from "views/AppFeatureControl/AppFeatureControlForm";
import EmailSmtpForm from "views/Smtp/EmailSmtpForm";

import AppUserProfileUpload from "views/UserProfile/AppUserProfileUpload";
import ContractList from "views/UserProfile/ContractList";
import ContractUpload from "views/UserProfile/ContractUpload";
import ContractDetailPage from "views/UserProfile/ContractDetailPage"
import ContractEditPage from "views/UserProfile/ContractEditPage"

import PushNotificationSettingsForm from "views/Notifications/PushNotification/PushNotificationSettings";
import BackOfficeUserProfileUpload from "views/UserProfile/BOUserProfileUpload";
import EstateSetup from "views/EstateSetup/EstateSetup";
import Error from "views/Error/Error";

import SOSList from "views/SOS/SOSList";
import SOSForm from "views/SOS/SOSForm";


/* mport AudioConverterByEachFile from "views/SOS/AudioConverterByEachFile";
import AudioConverterByBulk from "views/SOS/AudioConverterByBulk"; */


import FileUploadSetting from "views/GlobalConfiguration/FileUploadSetting";
import TranslationCountSetting from "views/GlobalConfiguration/TranslationCount";
import SOSSetting from "views/SOS/SOSSetting";
import MobileNumberChangeSetting from "views/GlobalConfiguration/MobileNumberChangeSetting";
import AudioSetting from "views/GlobalConfiguration/AudioSetting";
import PendingProfileList from "views/Worker/PendingProfileList";
import GlobalNonWorkingDay from "views/NonWorkingDay/Global";
import HariTerabaiDay from "views/NonWorkingDay/HariTerabai";
import WeekendNonWorkingDay from "views/NonWorkingDay/Weekend";
import GlobalForm from "views/NonWorkingDay/GlobalForm";
import HariTerabaiDayForm from "views/NonWorkingDay/HariTerabaiForm";
import WeekendNonWorkingDayForm from "views/NonWorkingDay/WeekendForm";
import ApprovedAndRejectedUsers from "views/User/ApprovedAndRejectedUsers";
import { checkRoutePermission } from "./routeUtils";
import AttendanceType from "views/Attendance/AttendanceType";
import AttendanceTypeForm from "views/Attendance/AttendanceTypeForm";
import EstateList from "views/EstateSetup/EstateList";
import EstateQRList from "views/EstateSetup/EstateQR";
import ApprovedAndRejectedProfile from "../views/Worker/ApprovedAndRejectedProfile";
import SOSRecipientList from "views/SOS/SOSRecipientList";
import MessageSettings from "views/Notifications/MessageSettings/MessageSettingsList";
import MessageSettingsEditForm from "views/Notifications/MessageSettings/MessageSettingsEditForm";
import AttendanceAddForm from "views/Attendance/AttendanceAddForm";
import Assignee from "@Views/Grievance/Setup/Assignee";

import BranchCreateForm from "@Views/MOHRBranch/BranchCreateForm";
import BranchEditForm from "@Views/MOHRBranch/BranchEditForm";
import BranchList from "@Views/MOHRBranch/BranchList";
import ShopList from "@Views/Shop/ShopList";
import ShopCreateForm from "@Views/Shop/ShopCreateForm";
import ShopEditForm from "views/Shop/ShopEditForm";
import PendingUserForm from "views/Worker/PendingApprovalEditForm";
import ApproveRejectedView from "views/Worker/ApproveAndRejectedProfileEditform";
import ApprovedAndRejectedUsersEditForm from "views/User/ApprovedAndRejectedUsersEditForm";
import ERMLList from "../views/ERML/ERMLList";
import ERMLSetting from "../views/ERML/ERMLSettings";

// Custom Fields
import WorkerGroupList from "views/CustomFields/WorkerGroup/WorkerGroup";
import WorkerGroupForm from "views/CustomFields/WorkerGroup/WorkerGroupForm";
import WorkerGroupAddForm from "views/CustomFields/WorkerGroup/WorkerGroupAddForm";

import WorkerGroupDetailPage from "views/CustomFields/WorkerGroup/WorkerGroupDetailPage";

import IDTypeList from "views/CustomFields/IDType/IdType";
import IdTypeForm from "views/CustomFields/IDType/IdTypeForm";
import GrievanceTypeList from "views/CustomFields/GrievanceType/GrievanceType";
import GrievanceTypeForm from "views/CustomFields/GrievanceType/GrievanceTypeForm";
import UrgencyLevelList from "views/CustomFields/UrgencyLevel/UrgencyLevel";
import UrgencyLevelForm from "views/CustomFields/UrgencyLevel/UrgencyLevelForm";
import DistrictList from "views/CustomFields/District/DistrictList";
import DistrictForm from "views/CustomFields/District/DistrictForm";
import StateList from "views/CustomFields/State/StateList";
import StateForm from "views/CustomFields/State/StateForm";
import SourceForm from "views/CustomFields/Source/SourceForm";
import CompanyForm from "views/CustomFields/Company/CompanyForm";


import ForceUpdate from "views/ForceUpdate/ForceUpdateList";
import ForceUpdateForm from "views/ForceUpdate/ForceUpdateForm";
import NewUserRequest from "../views/GlobalConfiguration/NewUserRequest";
import RoleAuditReport from "../views/AuditLog/RoleAuditReport";
import WorkerManagementLog from "../views/AuditLog/WorkerUserManagementLog";
import BOManagementLog from "../views/AuditLog/BOUserManagementLog";
import AttendanceTypeLog from "views/AuditLog/AttendanceTypeLog";
import AttendanceMethodLog from "views/AuditLog/AttendanceMethodLog";
import NonWorkingDayLog from "views/AuditLog/NonWorkingDay";
import WorkerGroupLog from "views/AuditLog/WorkerGroupLog";
import GrievanceTypeLog from "views/AuditLog/GrievanceTypeLog";
import UrgencyLevelLog from "views/AuditLog/UrgencyLevelLog";
import AudioSetupLog from "views/AuditLog/AudioSetupLog";
import TranslationCountLog from "views/AuditLog/TranslationCountLog";
import SOSTransactionLog from "views/AuditLog/SOSTransactionLog";
import GrievanceTransactionLog from "views/AuditLog/GrievanceTransactionLog";
import UserLogAccess from "views/AuditLog/UserLog/UserLogAccess";
import UserActiveInactiveLog from "views/AuditLog/UserLog/UserActiveInactiveLog";
import UserLastLoginLog from "views/AuditLog/UserLog/UserLastLoginLog";
import WorkerDetailPage from "views/Worker/WorkerDetailPage";
import BannerViewDetails from "views/Announcement/BannerViewDetails";
import SOSDetail from "views/SOS/SOSDetail";
import GrievanceDetail from "views/Grievance/GrievanceDetail";
import ShopDetail from "views/Shop/ShopDetail";
import BackOfficeUserDetail from "views/User/BackOfficeUserDetail";
import BranchDetail from "views/MOHRBranch/BranchDetail";
import AttendanceTypeDetail from "views/Attendance/AttendanceTypeDetail";
import GlobalDetail from "views/NonWorkingDay/GlobalDetail";
import RoleViewDetails from "views/UserManagement/Role/RoleViewDetails";
import PendingApprovalViewDetails from "views/Worker/PendingApprovalViewDetails";
import AttendanceViewDetails from "views/Attendance/AttendanceViewDetails";
import SupervisorAssignmentViewDetails from "views/SupervisorAssignment/SupervisorAssignmentViewDetails";
import WeekendViewDetails from "views/NonWorkingDay/WeekendViewDetails";
import HariTerabaiViewDetails from "views/NonWorkingDay/HariTerabaiViewDetails";
import PendingProfileUpdateEdit from "views/Worker/PendingProfileUpdateEdit";
import PendingProfileUpdateViewDetails from "views/Worker/PendingProfileUpdateViewDetails";
import WorkerUser from "views/AuditLog/Auditrailuser/WorkerUser";
import BackOfficeUser from "views/AuditLog/Auditrailuser/BackOfficeUser";
import AuditLogApi from "views/AuditLog/AuditLogFile/AuditLogApi";
import AuditLogExcel from "views/AuditLog/AuditLogFile/AuditLogExcel";
import HqViewReport from "views/Reports/Attendance Report/HqViewReport";
import EstateViewReport from "views/Reports/Attendance Report/EstateViewReport";

import policySummary from "views/Reports/Policy Report/policySummary";
import policyDetails from "views/Reports/Policy Report/policyDetails";
import boAccessReportMobileApp from "views/Reports/Backoffice Access Report/boAccessReportMobileApp";
import boAccessReportMobileAppDetails from "views/Reports/Backoffice Access Report/boAccessReportMobileAppDetails";
import boAccessBoPortal from "views/Reports/Backoffice Access Report/boAccessBoPortal";
import boAccessBoPortalDetails from "views/Reports/Backoffice Access Report/boAccessBoPortalDetails";
import workerAccess from "views/Reports/Worker Access Report/workerAccess";
import workerAccessByModule from "views/Reports/Worker Access Report/workerAccessByModule";
import workerAccessDetailReport from "views/Reports/Worker Access Report/workerAccessDetailReport";



import AttendanceWorkerGroup from "views/Attendance/WorkerGroup";
import AttendanceWorkerGroupForm from "views/Attendance/WorkerGroupForm";
import SmsReportList from "views/AuditLog/SmsReport/SmsReportList";
import AccountDeletionList from "views/User/AccountDeletionList";
import AccountDeletionViewDetails from "views/User/AccountDeletionViewDetails";
import SourceList from "views/CustomFields/Source/SourceList";
import CompanyList from "views/CustomFields/Company/CompanyList";
import RoleMappingForm from "views/CustomFields/Role Mapping/RoleMappingForm";
import RoleMappingList from "views/CustomFields/Role Mapping/RoleMappingList";

/**
 * Few things about dashboardRoutes
 * Its a route used to provide paths and fill the sidebar
 * Till now, it's nested upto 3 branches:
 * 1. Main route
 * 2. Collapsible routes:
 *    -> If the main route has attribute `collapsible: true` and contains list with key `items`...
 *    -> ...then they are collapsible routes.
 * 3. Sub routes:
 *    -> Sub routes are branches of collapsible branch, and are mainly used to add/edit forms
 *    -> If collapsible routes have list with key `subItems` then it's a sub route.
 *
 * Now, lets talk about routes permission:
 *    * To give a public permission to the route, you shouldn't put `module` key in your route
 *    * `module` permission to main route also gives collapsible and sub-routes the same permission
 *    * If you want to show few and hide few collapsible routes under same main routes...
 *      ...then you have to give specific permission to individual collapsible routes
 *    * Note that superuser has accesses to all APIs, but even superuser...
 *      ...should have modules to be shown all routes in frontend
 * @param modulesInReverseOrder
 */

let dashboardRoutes = [
  {
    path: MAIN_URL.DASHBOARD,
    name: PAGE_NAME.DASHBOARD,
    icon: faTachometerAlt,
    layout: Admin,
    component: AttendanceSummary,
    exact: true,
    collapsible: false,
    protected: true,
    module: MODULES.DASHBOARD,
  },
  {
    path: MAIN_URL.ANNOUNCEMENT,
    name: "Announcement",
    icon: faBullhorn,
    layout: Admin,
    component: Error,
    exact: true,
    collapsible: true,
    protected: true,
    items: [
      {
        name: "Banner Setup",
        exact: true,
        icon: faImage,
        path: ITEM_URL.BANNER,
        component: Error,
        subItems: [
          {
            name: PAGE_NAME.BANNER,
            module: PAGE_NAME.BANNER,
            path: SUB_ITEM_URL.BANNER_LIST,
            component: Banner,
            exact: true,
            icon: faImage,
          },
          
          {
            name: "Banner Edit",
            module: PAGE_NAME.BANNER,
            path: SUB_ITEM_URL.BANNER_LIST + "/edit/:id",
            component: BannerForm,
            exact: true,
            icon: faEdit,
            noTab: true,
          },
          {
            name: "Banner Add",
            module: PAGE_NAME.BANNER,
            path: SUB_ITEM_URL.BANNER_LIST + "/add",
            component: BannerForm,
            exact: false,
            icon: faPlus,
            noTab: true,
          },
          {
            name: PAGE_NAME.BANNER_COUNT,
            module: PAGE_NAME.BANNER_COUNT,
            path: SUB_ITEM_URL.BANNER_COUNT,
            component: BannerCountConfig,
            exact: true,
            icon: faListOl,
          },
          {
            name: "Banner View Details",
            module: PAGE_NAME.BANNER,
            path: SUB_ITEM_URL.BANNER_LIST + "/view-details/:id",
            component: BannerViewDetails,
            exact: true,
            noTab: true,
            icon: faListOl,
          },
        ],
      },
    ],
  },
  {
    path: MAIN_URL.USER,
    name: "User Management",
    icon: faUserCog,
    layout: Admin,
    exact: true,
    collapsible: true,
    protected: true,
    component: Error,
    items: [
      {
        name: "Role",
        path: ITEM_URL.ROLE,
        exact: true,
        icon: faUserTag,
        subItems: [
          {
            name: PAGE_NAME.ROLE,
            module: PAGE_NAME.ROLE,
            path: SUB_ITEM_URL.ROLE_LIST,
            component: Role,
            exact: true,
            icon: faList,
          },
          {
            name: "Role Edit",
            module: PAGE_NAME.ROLE,
            path: SUB_ITEM_URL.ROLE_LIST + "/edit/:id",
            component: RoleEditForm,
            exact: true,
            icon: faEdit,
            noTab: true,
          },
          {
            name: "Role View Details",
            module: PAGE_NAME.ROLE,
            path: SUB_ITEM_URL.ROLE_LIST + "/view-details/:id",
            component: RoleViewDetails,
            exact: true,
            icon: faEdit,
            noTab: true,
          },
          {
            name: "Role Add",
            module: PAGE_NAME.ROLE,
            path: SUB_ITEM_URL.ROLE_LIST + "/add",
            component: RoleForm,
            exact: true,
            icon: faPlus,
            noTab: true,
          },
        ],
      },
      {
        name: "Worker",
        exact: true,
        icon: faHardHat,
        path: ITEM_URL.WORKER,
        component: Error,
        subItems: [
          {
            name: PAGE_NAME.WORKER_USER,
            module: PAGE_NAME.WORKER_USER,
            path: SUB_ITEM_URL.WORKER_LIST,
            component: WorkerList,
            exact: true,
            icon: faHardHat,
          },
          {
            name: "Worker Edit",
            module: PAGE_NAME.WORKER_USER,
            path: SUB_ITEM_URL.WORKER_LIST + "/edit/:id",
            component: WorkerEditForm,
            exact: true,
            icon: faHardHat,
            noTab: true,
          },
          // {
          //   name: "Worker View",
          //   module: PAGE_NAME.WORKER_USER,
          //   path: SUB_ITEM_URL.WORKER_LIST + "/view-details/:id",
          //   component: WorkerViewForm,
          //   exact: true,
          //   icon: faHardHat,
          //   noTab: true,
          // },
          {
            name: "Worker Detail",
            module: PAGE_NAME.WORKER_USER,
            path: SUB_ITEM_URL.WORKER_LIST + "/view-details/:id",
            component: WorkerDetailPage,
            exact: true,
            icon: faHardHat,
            noTab: true,
          },
          {
            name: "Worker Add",
            module: PAGE_NAME.WORKER_USER,
            path: SUB_ITEM_URL.WORKER_LIST + "/add",
            component: WorkerCreateForm,
            exact: true,
            icon: faHardHat,
            noTab: true,
          },
          {
            name: PAGE_NAME.WORKER_FILE_UPLOAD,
            module: PAGE_NAME.WORKER_FILE_UPLOAD,
            path: SUB_ITEM_URL.APP_USER_PROFILE,
            component: AppUserProfileUpload,
            exact: true,
            icon: faUserCog,
          },
          {
            name: PAGE_NAME.WORKER_CONTRACT,
            module: PAGE_NAME.WORKER_CONTRACT_UPLOAD,
            path: SUB_ITEM_URL.WORKER_CONTRACTS,
            component: ContractList,
            exact: true,
            icon: faAddressBook,
          },
          {
            name: PAGE_NAME.WORKER_CONTRACT_UPLOAD,
            module: PAGE_NAME.WORKER_CONTRACT_UPLOAD,
            path: SUB_ITEM_URL.WORKER_CONTRACTS + "/add",
            component: ContractUpload,
            exact: true,
            noTab: true,
          },
          {
            name: PAGE_NAME.WORKER_CONTRACT_UPLOAD,
            module: PAGE_NAME.WORKER_CONTRACT_UPLOAD,
            path: SUB_ITEM_URL.WORKER_CONTRACTS + "/view-details/:id",
            component: ContractDetailPage,
            exact: true,
            noTab: true,
          },
          {
            name: PAGE_NAME.WORKER_CONTRACT_UPLOAD,
            module: PAGE_NAME.WORKER_CONTRACT_UPLOAD,
            path: SUB_ITEM_URL.WORKER_CONTRACTS + "/edit/:id",
            component: ContractEditPage,
            exact: true,
            noTab: true,
          },
        ],
      },
      {
        name: "Back Office",
        path: ITEM_URL.BACK_OFFICE,
        component: Error,
        exact: true,
        icon: faUserShield,
        subItems: [
          {
            name: PAGE_NAME.BACK_OFFICE_USER,
            module: PAGE_NAME.BACK_OFFICE_USER,
            path: SUB_ITEM_URL.BO_LIST,
            component: BackOfficeUserList,
            exact: true,
            icon: faList,
          },
          {
            name: "Back-Office User Edit",
            module: PAGE_NAME.BACK_OFFICE_USER,
            path: SUB_ITEM_URL.BO_LIST + "/edit/:id",
            component: BackOfficeUserEditForm,
            exact: true,
            icon: faEdit,
            noTab: true,
          },
          {
            name: "Back-Office User Detail",
            module: PAGE_NAME.BACK_OFFICE_USER,
            path: SUB_ITEM_URL.BO_LIST + "/view-details/:id",
            component: BackOfficeUserDetail,
            exact: true,
            icon: faEdit,
            noTab: true,
          },
          {
            name: "Back-Office User Add",
            module: PAGE_NAME.BACK_OFFICE_USER,
            path: SUB_ITEM_URL.BO_LIST + "/add",
            component: BackOfficeUserForm,
            exact: true,
            icon: faPlus,
            noTab: true,
          },
          {
            name: PAGE_NAME.BACK_OFFICE_FILE_UPLOAD,
            module: PAGE_NAME.BACK_OFFICE_FILE_UPLOAD,
            path: "/bo-user-profile",
            component: BackOfficeUserProfileUpload,
            exact: true,
            icon: faUserCog,
          },
        ],
      },
      {
        name: "Pending Approval",
        path: ITEM_URL.PENDING_APPROVAL,
        exact: true,
        icon: faUserClock,
        component: Error,
        subItems: [
          {
            name: PAGE_NAME.PENDING_USER,
            module: PAGE_NAME.PENDING_USER,
            path: SUB_ITEM_URL.PENDING_APPROVAL_LIST,
            component: PendingWorkerList,
            exact: true,
            icon: faList,
          },
          {
            name: "Pending User View",
            module: PAGE_NAME.PENDING_USER,
            path: SUB_ITEM_URL.PENDING_APPROVAL_LIST + "/edit/:id",
            component: PendingUserForm,
            exact: true,
            icon: faEdit,
            noTab: true,
          },
          {
            name: "Pending User View Details",
            module: PAGE_NAME.PENDING_USER,
            path: SUB_ITEM_URL.PENDING_APPROVAL_LIST + "/view-details/:id",
            component: PendingApprovalViewDetails,
            exact: true,
            icon: faEdit,
            noTab: true,
          },
          {
            name: PAGE_NAME.APPROVED_OR_REJECTED_USER,
            module: PAGE_NAME.APPROVED_OR_REJECTED_USER,
            path: SUB_ITEM_URL.NON_PENDING_USERS,
            component: ApprovedAndRejectedUsers,
            exact: true,
            icon: faUserCircle,
          },
          {
            name: "User",
            module: PAGE_NAME.APPROVED_OR_REJECTED_USER,
            path: SUB_ITEM_URL.NON_PENDING_USERS + "/view/:id",
            component: UserProfile,
            exact: true,
            icon: faEdit,
            noTab: true,
          },
          {
            name: PAGE_NAME.APPROVED_OR_REJECTED_USER,
            module: PAGE_NAME.APPROVED_OR_REJECTED_USER,
            path: SUB_ITEM_URL.NON_PENDING_USERS + "/edit/:id",
            component: ApprovedAndRejectedUsersEditForm,
            exact: true,
            icon: faEdit,
            noTab: true,
          },
          {
            name: PAGE_NAME.APPROVED_OR_REJECTED_USER,
            module: PAGE_NAME.APPROVED_OR_REJECTED_USER,
            path: SUB_ITEM_URL.NON_PENDING_USERS + "/view-details/:id",
            component: ApprovedAndRejectedUsersEditForm,
            exact: true,
            icon: faEdit,
            noTab: true,
          },
          {
            name: PAGE_NAME.PENDING_PROFILE_DATA,
            module: PAGE_NAME.PENDING_PROFILE_DATA,
            path: SUB_ITEM_URL.PENDING_APPROVAL_PROFILE,
            component: PendingProfileList,
            exact: true,
            icon: faHourglassStart,
            noTab: true,
          },
          {
            name: PAGE_NAME.PENDING_PROFILE_DATA,
            module: PAGE_NAME.PENDING_PROFILE_DATA,
            path: SUB_ITEM_URL.PENDING_APPROVAL_PROFILE,
            component: PendingProfileList,
            exact: true,
            icon: faHourglassStart,
          },
          {
            name: PAGE_NAME.PENDING_PROFILE_DATA,
            module: PAGE_NAME.PENDING_PROFILE_DATA,
            path: SUB_ITEM_URL.PENDING_APPROVAL_PROFILE + "/edit/:id",
            component: PendingProfileUpdateEdit,
            exact: true,
            icon: faHourglassStart,
            noTab: true,
          },
          {
            name: PAGE_NAME.PENDING_PROFILE_DATA,
            module: PAGE_NAME.PENDING_PROFILE_DATA,
            path: SUB_ITEM_URL.PENDING_APPROVAL_PROFILE + "/view-details/:id",
            component: PendingProfileUpdateViewDetails,
            exact: true,
            icon: faHourglassStart,
            noTab: true,
          },
          {
            name: PAGE_NAME.APPROVED_OR_REJECTED_PROFILE,
            module: PAGE_NAME.APPROVED_OR_REJECTED_PROFILE,
            path: SUB_ITEM_URL.NON_PENDING_PROFILES,
            component: ApprovedAndRejectedProfile,
            exact: true,
            icon: faUserCircle,
          },
          {
            name: "User",
            module: PAGE_NAME.APPROVED_OR_REJECTED_PROFILE,
            path: SUB_ITEM_URL.PENDING_APPROVAL_LIST + "/view/:id",
            component: UserProfile,
            exact: true,
            icon: faUser,
            noTab: true,
          },
          {
            name: PAGE_NAME.APPROVED_OR_REJECTED_PROFILE,
            module: PAGE_NAME.APPROVED_OR_REJECTED_PROFILE,
            path: SUB_ITEM_URL.NON_PENDING_PROFILES + "/edit/:id",
            component: ApproveRejectedView,
            exact: true,
            icon: faEdit,
            noTab: true,
          },
          {
            name: PAGE_NAME.ACCOUNT_DELETION,
            module: PAGE_NAME.ACCOUNT_DELETION,
            path: SUB_ITEM_URL.ACCOUNT_DELETION,
            component: AccountDeletionList,
            exact: true,
            icon: faList,
          },
          {
            name: "Delete Account Request Detail",
            module: PAGE_NAME.ACCOUNT_DELETION,
            path: SUB_ITEM_URL.ACCOUNT_DELETION + "/view-details/:id",
            component: AccountDeletionViewDetails,
            exact: true,
            icon: faHardHat,
            noTab: true,
          },
          {
            name: "Delete Account Request Edit",
            module: PAGE_NAME.ACCOUNT_DELETION,
            path: SUB_ITEM_URL.ACCOUNT_DELETION + "/edit/:id",
            component: AccountDeletionViewDetails,
            exact: true,
            icon: faHardHat,
            noTab: true,
          },
        ],
      },
    ],
  },
  {
    path: MAIN_URL.ATTENDANCE,
    name: "Attendance Management",
    icon: faQrcode,
    layout: Admin,
    exact: true,
    collapsible: true,
    protected: true,
    component: Error,
    items: [
      {
        name: "Attendance Record",
        path: ITEM_URL.ATTENDANCE_RECORD,
        exact: true,
        icon: faList,
        component: Error,

        subItems: [
          {
            name: PAGE_NAME.ATTENDANCE_RECORD,
            module: PAGE_NAME.ATTENDANCE_RECORD,
            path: SUB_ITEM_URL.ATTENDANCE_LIST,
            component: AttendanceRecord,
            exact: true,
            icon: faList,
          },
          {
            name: PAGE_NAME.ATTENDANCE_RECORD_BY_MONTH,
            module: PAGE_NAME.ATTENDANCE_RECORD_BY_MONTH,
            path: SUB_ITEM_URL.ATTENDANCE_BY_MONTH_LIST,
            component: AttendanceRecordByMonth,
            exact: true,
            icon: faList,
          },
          {
            name: "Attendance Edit",
            module: PAGE_NAME.ATTENDANCE_RECORD,
            path: SUB_ITEM_URL.ATTENDANCE_LIST + "/edit/:id",
            component: AttendanceForm,
            exact: false,
            icon: faEdit,
            noTab: true,
          },
          {
            name: "Attendance View Details",
            module: PAGE_NAME.ATTENDANCE_RECORD,
            path: SUB_ITEM_URL.ATTENDANCE_LIST + "/view-details/:id",
            component: AttendanceViewDetails,
            exact: false,
            icon: faEdit,
            noTab: true,
          },
          {
            name: "Worker Add",
            module: PAGE_NAME.WORKER_USER,
            path: SUB_ITEM_URL.WORKER_LIST + "/add",
            component: AttendanceAddForm,
            exact: true,
            icon: faHardHat,
            noTab: true,
          },
        ],
      },
      {
        name: "Supervisor Assignment",
        path: ITEM_URL.SUPERVISOR_ASSIGNMENT,
        component: Error,
        exact: true,
        icon: faUserTie,
        subItems: [
          {
            name: PAGE_NAME.SUPERVISOR_ASSIGNMENT,
            module: PAGE_NAME.SUPERVISOR_ASSIGNMENT,
            path: SUB_ITEM_URL.SUPERVISOR_ASSIGNMENT_LIST,
            component: SupervisorAssignmentList,
            exact: true,
            icon: faUserTie,
          },
          {
            name: "Assign Supervisor",
            module: PAGE_NAME.SUPERVISOR_ASSIGNMENT,
            path: SUB_ITEM_URL.SUPERVISOR_ASSIGNMENT_LIST + "/edit/:id",
            component: SupervisorAssignmentForm,
            exact: true,
            icon: faUserCog,
            noTab: true,
          },
          {
            name: "Assign Supervisor View Details",
            module: PAGE_NAME.SUPERVISOR_ASSIGNMENT,
            path: SUB_ITEM_URL.SUPERVISOR_ASSIGNMENT_LIST + "/view-details/:id",
            component: SupervisorAssignmentViewDetails,
            exact: true,
            icon: faUserCog,
            noTab: true,
          },
          {
            name: PAGE_NAME.BULK_SUPERVISOR_ASSIGNMENT,
            module: PAGE_NAME.BULK_SUPERVISOR_ASSIGNMENT,
            path: SUB_ITEM_URL.BULK_SUPERVISOR_ASSIGN,
            component: SupervisorBulkAssignment,
            exact: true,
            icon: faUsers,
          },
        ],
      },
      {
        name: "ERML File",
        path: ITEM_URL.ERML,
        exact: true,
        icon: faLeaf,
        component: Error,
        subItems: [
          {
            name: PAGE_NAME.ERML_FILE_DOWNLOAD,
            module: PAGE_NAME.ERML_FILE_DOWNLOAD,
            path: SUB_ITEM_URL.ERML_FILE_DOWNLOAD,
            component: ERMLList,
            exact: true,
            icon: faLeaf,
          },
          {
            name: PAGE_NAME.ERML_SETTINGS,
            module: PAGE_NAME.ERML_SETTINGS,
            path: SUB_ITEM_URL.ERML_SETTINGS,
            component: ERMLSetting,
            exact: true,
            icon: faSolarPanel,
          },
        ],
      },
      {
        name: "Attendance Setup",
        path: ITEM_URL.ATTENDANCE_SETUP,
        exact: true,
        icon: faCogs,
        component: Error,
        subItems: [
          {
            name: PAGE_NAME.ATTENDANCE_METHOD,
            module: PAGE_NAME.ATTENDANCE_METHOD,
            path: SUB_ITEM_URL.ATTENDANCE_METHOD,
            component: AttendanceMethod,
            exact: true,
            icon: faUserShield,
          },
          {
            name: PAGE_NAME.ATTENDANCE_TYPE,
            module: PAGE_NAME.ATTENDANCE_TYPE,
            path: SUB_ITEM_URL.ATTENDANCE_TYPE,
            component: AttendanceType,
            exact: true,
            icon: faFingerprint,
          },
          {
            name: "Attendance Type",
            module: PAGE_NAME.ATTENDANCE_TYPE,
            path: SUB_ITEM_URL.ATTENDANCE_TYPE + "/add",
            component: AttendanceTypeForm,
            exact: true,
            icon: faFingerprint,
            noTab: true,
          },
          {
            name: "Attendance Type",
            module: PAGE_NAME.ATTENDANCE_TYPE,
            path: SUB_ITEM_URL.ATTENDANCE_TYPE + "/edit/:id",
            component: AttendanceTypeForm,
            exact: true,
            icon: faFingerprint,
            noTab: true,
          },
          {
            name: "Attendance Type",
            module: PAGE_NAME.ATTENDANCE_TYPE,
            path: SUB_ITEM_URL.ATTENDANCE_TYPE + "/view-details/:id",
            component: AttendanceTypeDetail,
            exact: true,
            icon: faFingerprint,
            noTab: true,
          },
          {
            name: PAGE_NAME.PUSH_NOTIFICATION,
            module: PAGE_NAME.PUSH_NOTIFICATION,
            path: SUB_ITEM_URL.PUSH_NOTIFICATION_SETTINGS,
            component: PushNotificationSettingsForm,
            exact: true,
            icon: faBell,
          },
          {
            name: PAGE_NAME.NON_WORKING_DAY,
            module: PAGE_NAME.NON_WORKING_DAY,
            path: SUB_ITEM_URL.NON_WORKING_DAY_GLOBAL,
            component: GlobalNonWorkingDay,
            exact: true,
            icon: faUmbrellaBeach,
            radioInsideTab: true,
          },
          {
            name: "Non Working Day Add",
            module: PAGE_NAME.NON_WORKING_DAY,
            path: SUB_ITEM_URL.NON_WORKING_DAY_GLOBAL + "/add",
            exact: true,
            icon: faEdit,
            component: GlobalForm,
            noTab: true,
            radioInsideTab: true,
          },
          {
            name: "Non Working Day Edit",
            module: PAGE_NAME.NON_WORKING_DAY,
            path: SUB_ITEM_URL.NON_WORKING_DAY_GLOBAL + "/edit/:id",
            exact: true,
            icon: faEdit,
            component: GlobalForm,
            noTab: true,
            radioInsideTab: true,
          },
          {
            name: "Non Working Day Detail View",
            module: PAGE_NAME.NON_WORKING_DAY,
            path: SUB_ITEM_URL.NON_WORKING_DAY_GLOBAL + "/view-details/:id",
            exact: true,
            icon: faEdit,
            component: GlobalDetail,
            noTab: true,
            radioInsideTab: true,
          },
          {
            name: "Non Working Day",
            module: PAGE_NAME.NON_WORKING_DAY,
            path: SUB_ITEM_URL.NON_WORKING_DAY_HARI_TERABAI,
            component: HariTerabaiDay,
            exact: true,
            icon: faUmbrellaBeach,
            noTab: true,
            radioInsideTab: true,
          },
          {
            name: "Non Working Day Add",
            module: PAGE_NAME.NON_WORKING_DAY,
            path: SUB_ITEM_URL.NON_WORKING_DAY_HARI_TERABAI + "/add",
            component: HariTerabaiDayForm,
            exact: true,
            icon: faUmbrellaBeach,
            noTab: true,
            radioInsideTab: true,
          },
          {
            name: "Non Working Day Add",
            module: PAGE_NAME.NON_WORKING_DAY,
            path: SUB_ITEM_URL.NON_WORKING_DAY_HARI_TERABAI + "/edit/:id",
            component: HariTerabaiDayForm,
            exact: true,
            icon: faUmbrellaBeach,
            noTab: true,
            radioInsideTab: true,
          },
          {
            name: "Non Working Day View Details",
            module: PAGE_NAME.NON_WORKING_DAY,
            path:
              SUB_ITEM_URL.NON_WORKING_DAY_HARI_TERABAI + "/view-details/:id",
            component: HariTerabaiViewDetails,
            exact: true,
            icon: faUmbrellaBeach,
            noTab: true,
            radioInsideTab: true,
          },
          {
            name: "Non Working Day",
            module: PAGE_NAME.NON_WORKING_DAY,
            path: SUB_ITEM_URL.NON_WORKING_DAY_WEEKEND,
            component: WeekendNonWorkingDay,
            exact: true,
            icon: faUmbrellaBeach,
            noTab: true,
            radioInsideTab: true,
          },
          {
            name: "Non Working Day",
            module: PAGE_NAME.NON_WORKING_DAY,
            path: SUB_ITEM_URL.NON_WORKING_DAY_WEEKEND + "/add",
            component: WeekendNonWorkingDayForm,
            exact: true,
            icon: faUmbrellaBeach,
            noTab: true,
            radioInsideTab: true,
          },
          {
            name: "Non Working Day",
            module: PAGE_NAME.NON_WORKING_DAY,
            path: SUB_ITEM_URL.NON_WORKING_DAY_WEEKEND + "/edit/:id",
            component: WeekendNonWorkingDayForm,
            exact: true,
            icon: faUmbrellaBeach,
            noTab: true,
            radioInsideTab: true,
          },
          {
            name: "Non Working Day",
            module: PAGE_NAME.NON_WORKING_DAY,
            path: SUB_ITEM_URL.NON_WORKING_DAY_WEEKEND + "/view-details/:id",
            component: WeekendViewDetails,
            exact: true,
            icon: faUmbrellaBeach,
            noTab: true,
            radioInsideTab: true,
          },
          // FIXME: 10977 - Attendance Setup, worker group hidden for now
          // {
          //   name: "Worker Group",
          //   module: PAGE_NAME.ATTENDANCE_WORKER_GROUP,
          //   path: SUB_ITEM_URL.ATTENDANCE_WORKER_GROUP,
          //   component: AttendanceWorkerGroup,
          //   exact: true,
          //   icon: faTools,
          // },
          // {
          //   name: "Worker Group",
          //   module: PAGE_NAME.ATTENDANCE_WORKER_GROUP,
          //   path: SUB_ITEM_URL.ATTENDANCE_WORKER_GROUP + "/edit/:id",
          //   component: AttendanceWorkerGroupForm,
          //   noTab: true,
          //   exact: true,
          //   icon: faTools,
          // },
        ],
      },
      {
        name: "Estate Setup",
        path: ITEM_URL.ESTATE,
        exact: true,
        icon: faBuilding,
        component: Error,
        subItems: [
          {
            name: PAGE_NAME.ESTATE,
            module: PAGE_NAME.ESTATE,
            path: SUB_ITEM_URL.ESTATE,
            component: EstateList,
            exact: true,
            icon: faBuilding,
          },
          {
            name: PAGE_NAME.ESTATE_FILE_UPLOAD,
            module: PAGE_NAME.ESTATE_FILE_UPLOAD,
            path: SUB_ITEM_URL.ESTATE_UPLOAD,
            component: EstateSetup,
            exact: true,
            icon: faFileUpload,
          },
          {
            name: PAGE_NAME.ESTATE_QR,
            module: PAGE_NAME.ESTATE_QR,
            path: SUB_ITEM_URL.ESTATE_QR,
            component: EstateQRList,
            exact: true,
            icon: faQrcode,
          },
        ],
      },
    ],
  },
  {
    path: MAIN_URL.SOS,
    name: "SOS Management",
    icon: faFirstAid,
    layout: Admin,
    exact: true,
    collapsible: true,
    protected: true,
    component: Error,
    items: [
      {
        name: "SOS Record",
        path: ITEM_URL.SOS,
        exact: true,
        component: Error,
        icon: faFileMedicalAlt,
        subItems: [
          {
            name: PAGE_NAME.SOS_RECORD,
            module: PAGE_NAME.SOS_RECORD,
            path: SUB_ITEM_URL.SOS_LIST,
            component: SOSList,
            exact: true,
            icon: faFileMedicalAlt,
          },
          {
            name: "SOS Edit",
            module: PAGE_NAME.SOS_RECORD,
            path: SUB_ITEM_URL.SOS_LIST + "/edit/:id",
            component: SOSForm,
            exact: false,
            icon: faEdit,
            noTab: true,
          },
          {
            name: "SOS Detail",
            module: PAGE_NAME.SOS_RECORD,
            path: SUB_ITEM_URL.SOS_LIST + "/view-details/:id",
            component: SOSDetail,
            exact: true,
            icon: faHardHat,
            noTab: true,
          },
        ],
      },
      {
        name: "SOS Setup",
        path: ITEM_URL.SOS_SETUP,
        exact: true,
        component: Error,
        icon: faLaptopMedical,
        subItems: [
          {
            name: PAGE_NAME.DAILY_SUBMISSION_LIMIT,
            module: PAGE_NAME.DAILY_SUBMISSION_LIMIT,
            path: SUB_ITEM_URL.SOS_COUNT,
            component: SOSSetting,
            exact: true,
            icon: faStopwatch20,
          },
          {
            name: PAGE_NAME.SOS_RECIPIENT,
            module: PAGE_NAME.SOS_RECIPIENT,
            path: SUB_ITEM_URL.SOS_RECIPIENT,
            component: SOSRecipientList,
            exact: false,
            icon: faUserNurse,
          },
        ],
      },
      /* {
        name: "Audio Converter",
        path: "/audio-converter",
        exact: true,
        component: Error,
        icon: faFileAudio,
        subItems: [
          {
            name: "Multiple Files by Array",
            module: PAGE_NAME.ESTATE,
            path: "/multiple-files",
            component: AudioConverterByEachFile,
            exact: true,
            icon: faFileAudio,
          },
          {
            name: "Multiple Files by Bulk",
            module: PAGE_NAME.ESTATE,
            path: "/multiple-files-by-zipped",
            component: AudioConverterByBulk,
            exact: true,
            icon: faFileAudio,
          },
        ],
      }, */
    ],
  },
  {
    path: MAIN_URL.GRIEVANCE,
    name: "Grievance Management",
    icon: faHeartBroken,
    layout: Admin,
    component: Error,
    exact: true,
    collapsible: true,
    protected: true,
    items: [
      {
        name: "Grievance Records",
        path: ITEM_URL.GRIEVANCE,
        component: Error,
        exact: true,
        icon: faList,
        subItems: [
          {
            name: PAGE_NAME.GRIEVANCE_RECORDS,
            module: PAGE_NAME.GRIEVANCE_RECORDS,
            path: SUB_ITEM_URL.GRIEVANCE_LIST,
            component: GrievanceList,
            exact: true,
            icon: faList,
          },
          {
            name: "Grievance Edit",
            module: PAGE_NAME.GRIEVANCE_RECORDS,
            path: SUB_ITEM_URL.GRIEVANCE_LIST + "/edit/:id",
            component: GrievanceEditForm,
            exact: true,
            icon: faEdit,
            noTab: true,
          },
          {
            name: "Grievance Detail",
            module: PAGE_NAME.GRIEVANCE_RECORDS,
            path: SUB_ITEM_URL.GRIEVANCE_LIST + "/view-details/:id",
            component: GrievanceDetail,
            exact: true,
            icon: faHardHat,
            noTab: true,
          },
        ],
      },
      {
        name: "Grievance Setup",
        path: ITEM_URL.GRIEVANCE_SETUP,
        component: Error,
        exact: true,
        icon: faHeartbeat,
        subItems: [
          {
            name: PAGE_NAME.ASSIGNEE,
            module: PAGE_NAME.ASSIGNEE,
            path: SUB_ITEM_URL.GRIEVANCE_ASSIGNEE,
            component: Assignee,
            exact: true,
            icon: faUserMd,
          },
        ],
      },
    ],
  },
  {
    path: MAIN_URL.KEDAI_FGV,
    name: "FGV Shop",
    icon: faHome,
    layout: Admin,
    component: Error,
    exact: true,
    collapsible: true,
    protected: true,
    items: [
      {
        name: "Contact List",
        path: ITEM_URL.KEDAI_CONTACT_LIST,
        component: Error,
        exact: true,
        icon: faPhoneSquare,
        subItems: [
          {
            name: PAGE_NAME.KEDAI_CONTACT_LIST,
            path: SUB_ITEM_URL.KEDAI_CONTACT_LIST,
            module: PAGE_NAME.KEDAI_CONTACT_LIST,
            component: ShopList,
            exact: true,
            icon: faPhone,
          },
          {
            name: "Contact List",
            path: SUB_ITEM_URL.KEDAI_CONTACT_LIST + "/add",
            module: PAGE_NAME.KEDAI_CONTACT_LIST,
            component: ShopCreateForm,
            exact: true,
            noTab: true,
          },
          {
            name: "Contact List",
            path: SUB_ITEM_URL.KEDAI_CONTACT_LIST + "/edit/:id",
            module: PAGE_NAME.KEDAI_CONTACT_LIST,
            component: ShopEditForm,
            exact: false,
            icon: faEdit,
            noTab: true,
          },
          {
            name: "Contact List",
            path: SUB_ITEM_URL.KEDAI_CONTACT_LIST + "/view-details/:id",
            module: PAGE_NAME.KEDAI_CONTACT_LIST,
            component: ShopDetail,
            exact: false,
            icon: faEdit,
            noTab: true,
          },
        ],
      },
    ],
  },
  {
    path: MAIN_URL.MOHR_BRANCH,
    name: "MOHR Branch",
    icon: faBuilding,
    layout: Admin,
    component: Error,
    exact: true,
    collapsible: true,
    protected: true,
    items: [
      {
        name: "Branch Setup",
        path: ITEM_URL.MOHR_BRANCH_SETUP,
        component: Error,
        exact: true,
        icon: faMapMarkerAlt,
        subItems: [
          {
            name: PAGE_NAME.MOHR_BRANCH_SETUP,
            module: PAGE_NAME.MOHR_BRANCH_SETUP,
            path: SUB_ITEM_URL.MOHR_BRANCH_SETUP,
            component: BranchList,
            exact: true,
            icon: faMapPin,
          },
          {
            name: "Branch Add",
            path: SUB_ITEM_URL.MOHR_BRANCH_SETUP + "/add",
            module: PAGE_NAME.MOHR_BRANCH_SETUP,
            component: BranchCreateForm,
            exact: true,
            noTab: true,
          },
          {
            name: "Branch Update",
            path: SUB_ITEM_URL.MOHR_BRANCH_SETUP + "/edit/:id",
            module: PAGE_NAME.MOHR_BRANCH_SETUP,
            component: BranchEditForm,
            exact: false,
            icon: faEdit,
            noTab: true,
          },
          {
            name: "Branch Detail",
            path: SUB_ITEM_URL.MOHR_BRANCH_SETUP + "/view-details/:id",
            module: PAGE_NAME.MOHR_BRANCH_SETUP,
            component: BranchDetail,
            exact: false,
            icon: faEdit,
            noTab: true,
          },
        ],
      },
    ],
  },

  {
    path: MAIN_URL.CONFIGURATIONS,
    name: "Configurations",
    icon: faSlidersH,
    layout: Admin,
    component: Error,
    exact: true,
    collapsible: true,
    protected: true,
    items: [
      {
        name: "Mobile App",
        path: ITEM_URL.MOBILE,
        component: Error,
        exact: true,
        icon: faMobileAlt,
        subItems: [
          {
            name: PAGE_NAME.MOBILE_CHANGE,
            module: PAGE_NAME.MOBILE_CHANGE,
            path: SUB_ITEM_URL.MOBILE_NUMBER_CHANGE,
            component: MobileNumberChangeSetting,
            exact: true,
            icon: faPhone,
          },
          {
            name: PAGE_NAME.NEW_USER_REQUEST,
            module: PAGE_NAME.NEW_USER_REQUEST,
            path: SUB_ITEM_URL.NEW_USER_REQUEST,
            component: NewUserRequest,
            exact: true,
            icon: faUser,
          },
          {
            name: PAGE_NAME.FEATURE_CONTROL,
            module: PAGE_NAME.FEATURE_CONTROL,
            path: SUB_ITEM_URL.FEATURE_CONTROL_MODULE,
            component: AppFeatureControlList,
            exact: true,
            icon: faCodeBranch,
          },
          {
            name: "Feature Control: Edit",
            module: PAGE_NAME.FEATURE_CONTROL,
            path: SUB_ITEM_URL.FEATURE_CONTROL_MODULE + "/edit/:id",
            component: AppFeatureControlForm,
            exact: true,
            icon: faEdit,
            noTab: true,
          },
        ],
      },
      {
        name: "Upload File",
        path: ITEM_URL.UPLOAD_FILE,
        component: Error,
        exact: true,
        icon: faUpload,
        subItems: [
          {
            name: PAGE_NAME.UPLOAD_FILE_SIZE_SETTING,
            module: PAGE_NAME.UPLOAD_FILE_SIZE_SETTING,
            path: SUB_ITEM_URL.UPLOAD_SIZE,
            component: FileUploadSetting,
            exact: true,
            icon: faUpload,
          },
        ],
      },
      {
        name: "Audio & Translation",
        path: ITEM_URL.AUDIO_TRANSLATION,
        component: Error,
        exact: true,
        icon: faVolumeUp,
        subItems: [
          {
            name: PAGE_NAME.AUDIO_SETTING,
            module: PAGE_NAME.AUDIO_SETTING,
            path: SUB_ITEM_URL.AUDIO_SETTINGS,
            component: AudioSetting,
            exact: true,
            icon: faVolumeUp,
          },
          {
            name: PAGE_NAME.MAX_TRANSLATION_COUNT,
            module: PAGE_NAME.MAX_TRANSLATION_COUNT,
            path: SUB_ITEM_URL.TRANSLATION_COUNT,
            component: TranslationCountSetting,
            exact: true,
            icon: faLanguage,
          },
        ],
      },
      {
        name: "Notification Setting",
        path: ITEM_URL.NOTIFICATION_SETTING,
        component: Error,
        exact: true,
        icon: faBell,
        subItems: [
          {
            name: PAGE_NAME.NOTIFICATION_SETTING,
            module: PAGE_NAME.NOTIFICATION_SETTING,
            exact: true,
            path: SUB_ITEM_URL.MESSAGE_NOTIFICATION,
            component: MessageSettings,
            icon: faBell,
          },
          {
            name: "Notification Message Edit",
            module: PAGE_NAME.NOTIFICATION_SETTING,
            path: SUB_ITEM_URL.MESSAGE_NOTIFICATION + "/edit/:id",
            component: MessageSettingsEditForm,
            exact: true,
            icon: faBell,
            noTab: true,
          },
        ],
      },
      {
        name: "Custom Field",
        path: ITEM_URL.SYSTEM,
        component: Error,
        exact: true,
        icon: faTools,
        subItems: [
          {
            name: PAGE_NAME.CUSTOM_FIELD,
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_WORKER_GROUP,
            component: WorkerGroupList,
            exact: true,
            icon: faTools,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_WORKER_GROUP + "/add",
            exact: true,
            icon: faEdit,
            component: WorkerGroupAddForm,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_WORKER_GROUP + "/edit/:id",
            exact: true,
            icon: faEdit,
            component: WorkerGroupForm,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_WORKER_GROUP + "/view-details/:id",
            exact: true,
            component: WorkerGroupDetailPage,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_ID_TYPES,
            component: IDTypeList,
            icon: faList,
            exact: true,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_ID_TYPES + "/add",
            component: IdTypeForm,
            icon: faList,
            exact: true,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_ID_TYPES + "/edit/:id",
            component: IdTypeForm,
            icon: faList,
            exact: true,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_GRIEVANCE_TYPE,
            component: GrievanceTypeList,
            icon: faList,
            exact: true,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_GRIEVANCE_TYPE + "/add",
            component: GrievanceTypeForm,
            icon: faList,
            exact: true,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_GRIEVANCE_TYPE + "/edit/:id",
            component: GrievanceTypeForm,
            icon: faList,
            exact: true,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_URGENCY_LEVEL,
            component: UrgencyLevelList,
            icon: faList,
            exact: true,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_URGENCY_LEVEL + "/add",
            component: UrgencyLevelForm,
            icon: faList,
            exact: true,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_URGENCY_LEVEL + "/edit/:id",
            component: UrgencyLevelForm,
            icon: faList,
            exact: true,
            noTab: true,
          },
          {
            name: PAGE_NAME.CUSTOM_FIELD,
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_DISTRICT,
            component: DistrictList,
            exact: true,
            icon: faTools,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_DISTRICT + "/add",
            exact: true,
            icon: faEdit,
            component: DistrictForm,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_DISTRICT + "/edit/:id",
            exact: true,
            icon: faEdit,
            component: DistrictForm,
            noTab: true,
          },
          {
            name: PAGE_NAME.CUSTOM_FIELD,
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_SOURCE,
            component: SourceList,
            icon: faList,
            exact: true,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_SOURCE + "/add",
            exact: true,
            icon: faEdit,
            component: SourceForm,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_SOURCE + "/edit/:id",
            exact: true,
            icon: faEdit,
            component: SourceForm,
            noTab: true,
          },
          {
            name: PAGE_NAME.CUSTOM_FIELD,
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_ROLEMAPPING,
            component: RoleMappingList,
            icon: faList,
            exact: true,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_ROLEMAPPING + "/add",
            exact: true,
            icon: faEdit,
            component: RoleMappingForm,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_ROLEMAPPING + "/edit/:id",
            exact: true,
            icon: faEdit,
            component: RoleMappingForm,
            noTab: true,
          },
          {
            name: PAGE_NAME.CUSTOM_FIELD,
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_COMPANY,
            component: CompanyList,
            icon: faList,
            exact: true,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_COMPANY + "/add",
            exact: true,
            icon: faEdit,
            component: CompanyForm,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_COMPANY + "/edit/:id",
            exact: true,
            icon: faEdit,
            component: CompanyForm,
            noTab: true,
          },
          {
            name: PAGE_NAME.CUSTOM_FIELD,
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_STATE,
            component: StateList,
            exact: true,
            icon: faTools,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_STATE + "/add",
            exact: true,
            icon: faEdit,
            component: StateForm,
            noTab: true,
          },
          {
            name: "Custom Field",
            module: PAGE_NAME.CUSTOM_FIELD,
            path: SUB_ITEM_URL.CUSTOM_FIELDS_STATE + "/edit/:id",
            exact: true,
            icon: faEdit,
            component: StateForm,
            noTab: true,
          },
        ],
      },
      {
        name: "System Setting",
        path: ITEM_URL.EXTRAS,
        component: Error,
        exact: true,
        icon: faUserCog,
        subItems: [
          {
            name: PAGE_NAME.SMTP_SETTINGS,
            module: PAGE_NAME.SMTP_SETTINGS,
            path: SUB_ITEM_URL.SMTP_SETTINGS,
            component: EmailSmtpForm,
            exact: true,
            icon: faEnvelope,
          },
          {
            name: PAGE_NAME.FORCE_UPDATE_SETTINGS,
            module: PAGE_NAME.FORCE_UPDATE_SETTINGS,
            path: SUB_ITEM_URL.FORCE_UPDATE_SETTINGS,
            component: ForceUpdate,
            exact: true,
            icon: faEnvelope,
            noTab: true,
          },
          {
            name: "AppVersion Edit",
            module: PAGE_NAME.FORCE_UPDATE_SETTINGS,
            path: SUB_ITEM_URL.FORCE_UPDATE_SETTINGS + "/edit/:id",
            component: ForceUpdateForm,
            exact: true,
            icon: faEdit,
            noTab: true,
          },
          {
            name: "AppVersion Add",
            module: PAGE_NAME.FORCE_UPDATE_SETTINGS,
            path: SUB_ITEM_URL.FORCE_UPDATE_SETTINGS + "/add",
            component: ForceUpdateForm,
            exact: false,
            icon: faPlus,
            noTab: true,
          },
        ],
      },

    ],
  },
  {
    path: MAIN_URL.AUDIT_TRIAL,
    name: "Audit Log",
    icon: faClipboardCheck,
    layout: Admin,
    component: Error,
    exact: true,
    collapsible: true,
    protected: true,
    items: [
      {
        name: "SMS Report",
        path: ITEM_URL.SMS_REPORT,
        component: Error,
        exact: true,
        icon: faPhoneSquare,
        subItems: [
          {
            name: PAGE_NAME.SMS_REPORT,
            path: SUB_ITEM_URL.SMS_REPORT,
            module: PAGE_NAME.SMS_REPORT,
            component: SmsReportList,
            exact: true,
            icon: faPhone,
          },
        ],
      },
      {
        name: "Last Login Log",
        exact: true,
        icon: faFileInvoice,
        path: ITEM_URL.AUDIT_TRIAL_USER,
        component: Error,
        subItems: [
          {
            name: PAGE_NAME.AUDIT_WORKER_USER,
            module: PAGE_NAME.AUDIT_WORKER_USER,
            path: SUB_ITEM_URL.AUDIT_USER_MANAGEMENT,
            component: WorkerUser,
            exact: true,
            icon: faHardHat,
          },
          
          {
            name: PAGE_NAME.AUDIT_BACKOFFICE_USER,
            module: PAGE_NAME.AUDIT_BACKOFFICE_USER,
            path: SUB_ITEM_URL.AUDIT_BO_MANAGEMENT,
            component: BackOfficeUser,
            exact: true,
            icon: faUserShield,
          },
          
        ],
      },
      {
        name: "Audit Log File",
        exact: true,
        icon: faFileInvoice,
        path: ITEM_URL.AUDIT_LOG_FILE,
        component: Error,
        subItems: [
          {
            name: PAGE_NAME.AUDIT_LOG_API,
            module: PAGE_NAME.AUDIT_LOG_API,
            path: SUB_ITEM_URL.AUDIT_LOG_FILE,
            component: AuditLogApi,
            exact: true,
            icon: faFileInvoice,
          },
         
          // {
          //   name: PAGE_NAME.AUDIT_LOG_EXCEL,
          //   module: PAGE_NAME.AUDIT_LOG_EXCEL,
          //   path: SUB_ITEM_URL.AUDIT_LOG_EXCEL,
          //   component: AuditLogExcel,
          //   exact: true,
          //   icon: faFileExcel,
          // },
          
        ],
      },

      
      

    ],
  },
  {
    path: MAIN_URL.REPORT,
    name: "Report",
    icon: faFileInvoice,
    layout: Admin,
    component: Error,
    exact: true,
    collapsible: true,
    protected: true,
    items: [
      {
        name: "Worker Access Report",
        exact: true,
        icon: faFileInvoice,
        path: ITEM_URL.WORKER_ACCESS_REPORT,
        component: Error,
        subItems: [
          {
            name: PAGE_NAME.WORKER_ACCESS,
            module: PAGE_NAME.WORKER_ACCESS,
            path: SUB_ITEM_URL.WORKER_ACCESS,
            component: workerAccess,
            exact: true,
            icon: faFileInvoice,
          },
         
          {
            name: PAGE_NAME.WORKER_ACCESS_BY_MODULE,
            module: PAGE_NAME.WORKER_ACCESS_BY_MODULE,
            path: SUB_ITEM_URL.WORKER_ACCESS_BY_MODULE,
            component: workerAccessByModule,
            exact: true,
            icon: faFileInvoice,
          },
          {
            name: PAGE_NAME.WORKER_ACCESS_DETAIL_REPORT,
            module: PAGE_NAME.WORKER_ACCESS_DETAIL_REPORT,
            path: SUB_ITEM_URL.WORKER_ACCESS_DETAIL_REPORT,
            component: workerAccessDetailReport,
            exact: true,
            icon: faFileInvoice,
          },               
        ],
      },

      {
        name: "Backoffice Access Report",
        exact: true,
        icon: faFileInvoice,
        path: ITEM_URL.BACKOFFICE_ACCESS_REPORT,
        component: Error,
        subItems: [
          {
            name: PAGE_NAME.BACKOFFICE_MOBILE_APP,
            module: PAGE_NAME.BACKOFFICE_MOBILE_APP,
            path: SUB_ITEM_URL.BACKOFFICE_MOBILE_APP,
            component: boAccessReportMobileApp,
            exact: true,
            icon: faFileInvoice,
          },
         
          {
            name: PAGE_NAME.BACKOFFICE_MOBILE_APP_DETAILS,
            module: PAGE_NAME.BACKOFFICE_MOBILE_APP_DETAILS,
            path: SUB_ITEM_URL.BACKOFFICE_MOBILE_APP_DETAILS,
            component: boAccessReportMobileAppDetails,
            exact: true,
            icon: faFileInvoice,
          },
          {
            name: PAGE_NAME.BACKOFFICE_BO_PORTAL,
            module: PAGE_NAME.BACKOFFICE_BO_PORTAL,
            path: SUB_ITEM_URL.BACKOFFICE_BO_PORTAL,
            component: boAccessBoPortal,
            exact: true,
            icon: faFileInvoice,
          },
          {
            name: PAGE_NAME.BACKOFFICE_BO_PORTAL_DETAILS,
            module: PAGE_NAME.BACKOFFICE_BO_PORTAL_DETAILS,
            path: SUB_ITEM_URL.BACKOFFICE_BO_PORTAL_DETAILS,
            component: boAccessBoPortalDetails,
            exact: true,
            icon: faFileInvoice,
          },

          
        ],
      },
     

      {
        name: "Policy Report",
        exact: true,
        icon: faFileInvoice,
        path: ITEM_URL.POLICY_REPORT,
        component: Error,
        subItems: [
          {
            name: PAGE_NAME.POLICY_DASHBOARD,
            module: PAGE_NAME.POLICY_DASHBOARD,
            path: SUB_ITEM_URL.POLICY_DASHBOARD,
            component: policySummary,
            exact: true,
            icon: faFileInvoice,
          },
         
          {
            name: PAGE_NAME.POLICY_DETAILS,
            module: PAGE_NAME.POLICY_DETAILS,
            path: SUB_ITEM_URL.POLICY_DETAILS,
            component: policyDetails,
            exact: true,
            icon: faFileInvoice,
          },
          
        ],
      },
      

      {
        name: "Attendance Report",
        exact: true,
        icon: faFileInvoice,
        path: ITEM_URL.ATTENDANCE_REPORT,
        component: Error,
        subItems: [
          {
            name: PAGE_NAME.REPORT_HQ_VIEW,
            module: PAGE_NAME.REPORT_HQ_VIEW,
            path: SUB_ITEM_URL.REPORT_HQ_VIEW,
            component: HqViewReport,
            exact: true,
            icon: faFileInvoice,
          },
         
          {
            name: PAGE_NAME.REPORT_ESTATE_VIEW,
            module: PAGE_NAME.REPORT_ESTATE_VIEW,
            path: SUB_ITEM_URL.REPORT_ESTATE_VIEW,
            component: EstateViewReport,
            exact: true,
            icon: faFileInvoice,
          },
          
        ],
      },
      
      

    ],
  },

  // FIXME: 10037 - Audit Logs hidden for now

  // {
  //   path: MAIN_URL.AUDIT_TRIAL,
  //   name: "Audit Trial",
  //   icon: faClipboardCheck,
  //   layout: Admin,
  //   component: Error,
  //   exact: true,
  //   collapsible: true,
  //   protected: true,
  //   items: [
  //     {
  //       name: "Audit Trial Setup",
  //       path: ITEM_URL.AUDIT_TRIAL_SETUP,
  //       component: Error,
  //       exact: true,
  //       icon: faTools,
  //       subItems: [
  //         {
  //           name: PAGE_NAME.AUDIT_ROLE_SETUP,
  //           module: PAGE_NAME.AUDIT_ROLE_SETUP,
  //           path: SUB_ITEM_URL.AUDIT_ROLE_SETUP,
  //           component: RoleAuditReport,
  //           exact: true,
  //           icon: faUserTag,
  //         },
  //         {
  //           name: PAGE_NAME.AUDIT_ATTENDANCE_SETUP,
  //           module: PAGE_NAME.AUDIT_ATTENDANCE_SETUP,
  //           path: SUB_ITEM_URL.AUDIT_ATTENDANCE_SETUP_ATTENDANCE_TYPE,
  //           component: AttendanceTypeLog,
  //           exact: true,
  //           icon: faCogs,
  //           radioInsideTab: true,
  //         },
  //         {
  //           name: PAGE_NAME.AUDIT_ATTENDANCE_METHOD,
  //           module: PAGE_NAME.AUDIT_ATTENDANCE_METHOD,
  //           path: SUB_ITEM_URL.AUDIT_ATTENDANCE_SETUP_ATTENDANCE_METHOD,
  //           component: AttendanceMethodLog,
  //           exact: true,
  //           noTab: true,
  //           icon: faBell,
  //           radioInsideTab: true,
  //         },
  //         {
  //           name: PAGE_NAME.AUDIT_ATTENDANCE_SETUP_NON_WORKING_DAY,
  //           module: PAGE_NAME.AUDIT_ATTENDANCE_SETUP_NON_WORKING_DAY,
  //           path: SUB_ITEM_URL.AUDIT_ATTENDANCE_SETUP_NON_WORKING_DAY,
  //           component: NonWorkingDayLog,
  //           exact: true,
  //           noTab: true,
  //           icon: faMapPin,
  //           radioInsideTab: true,
  //         },
  //         {
  //           name: PAGE_NAME.AUDIT_CUSTOM_SETUP,
  //           module: PAGE_NAME.AUDIT_CUSTOM_SETUP,
  //           path: SUB_ITEM_URL.AUDIT_CUSTOM_SETUP_WORKER_GROUP,
  //           component: WorkerGroupLog,
  //           exact: true,
  //           icon: faBell,
  //           radioInsideTab: true,
  //         },
  //         {
  //           name: PAGE_NAME.AUDIT_CUSTOM_SETUP_GRIEVANCE_TYPE,
  //           module: PAGE_NAME.AUDIT_CUSTOM_SETUP_GRIEVANCE_TYPE,
  //           path: SUB_ITEM_URL.AUDIT_CUSTOM_SETUP_GRIEVANCE_TYPE,
  //           component: GrievanceTypeLog,
  //           exact: true,
  //           noTab: true,
  //           icon: faMapPin,
  //           radioInsideTab: true,
  //         },
  //         {
  //           name: PAGE_NAME.AUDIT_CUSTOM_SETUP_URGENCY_LEAVE,
  //           module: PAGE_NAME.AUDIT_CUSTOM_SETUP_URGENCY_LEAVE,
  //           path: SUB_ITEM_URL.AUDIT_CUSTOM_SETUP_URGENCY_LEAVE,
  //           component: UrgencyLevelLog,
  //           exact: true,
  //           noTab: true,
  //           icon: faMapPin,
  //           radioInsideTab: true,
  //         },
  //         {
  //           name: PAGE_NAME.AUDIT_AUDIO_SETUP,
  //           module: PAGE_NAME.AUDIT_AUDIO_SETUP,
  //           path: SUB_ITEM_URL.AUDIT_AUDIO_SETUP,
  //           component: AudioSetupLog,
  //           exact: true,
  //           icon: faMicrophoneAlt,
  //         },
  //         {
  //           name: PAGE_NAME.AUDIT_TRANSLATION_COUNT,
  //           module: PAGE_NAME.AUDIT_TRANSLATION_COUNT,
  //           path: SUB_ITEM_URL.AUDIT_TRANSLATION_COUNT,
  //           component: TranslationCountLog,
  //           exact: true,
  //           icon: faLanguage,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Audit Trial Transaction",
  //       path: ITEM_URL.AUDIT_TRIAL_TRANSACTION,
  //       component: Error,
  //       exact: true,
  //       icon: faPenNib,
  //       subItems: [
  //         {
  //           name: PAGE_NAME.AUDIT_SOS_TRANSACTION,
  //           module: PAGE_NAME.AUDIT_SOS_TRANSACTION,
  //           path: SUB_ITEM_URL.AUDIT_SOS_TRANSACTION,
  //           component: SOSTransactionLog,
  //           exact: true,
  //           icon: faFirstAid,
  //         },
  //         {
  //           name: PAGE_NAME.AUDIT_GRIEVANCE_TRANSACTION,
  //           module: PAGE_NAME.AUDIT_GRIEVANCE_TRANSACTION,
  //           path: SUB_ITEM_URL.AUDIT_GRIEVANCE_TRANSACTION,
  //           component: GrievanceTransactionLog,
  //           exact: true,
  //           icon: faHeartBroken,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Audit Trail User Management",
  //       path: ITEM_URL.AUDIT_USER_MANAGEMENT,
  //       component: Error,
  //       exact: true,
  //       icon: faUserClock,
        // subItems: [
        //   {
        //     name: PAGE_NAME.AUDIT_WORKER_MANAGEMENT,
        //     module: PAGE_NAME.AUDIT_WORKER_MANAGEMENT,
        //     path: SUB_ITEM_URL.AUDIT_WORKER_MANAGEMENT,
        //     component: WorkerManagementLog,
        //     exact: true,
        //     icon: faUserClock,
        //   },
        //   {
        //     name: PAGE_NAME.AUDIT_BO_MANAGEMENT,
        //     module: PAGE_NAME.AUDIT_BO_MANAGEMENT,
        //     path: SUB_ITEM_URL.AUDIT_BO_MANAGEMENT,
        //     component: BOManagementLog,
        //     exact: true,
        //     icon: faUserTie,
        //   },
        // ],
  //     },
  //     {
  //       name: "Audit Trail User Log",
  //       path: ITEM_URL.AUDIT_USER_LOG,
  //       component: Error,
  //       exact: true,
  //       icon: faUserClock,
  //       subItems: [
  //         {
  //           name: PAGE_NAME.AUDIT_USER_ACCESS_LOG,
  //           module: PAGE_NAME.AUDIT_USER_ACCESS_LOG,
  //           path: SUB_ITEM_URL.AUDIT_USER_ACCESS_LOG,
  //           component: UserLogAccess,
  //           exact: true,
  //           icon: faUserClock,
  //         },
  //         {
  //           name: PAGE_NAME.AUDIT_USER_ACTIVE_INACTIVE_LOG,
  //           module: PAGE_NAME.AUDIT_USER_ACTIVE_INACTIVE_LOG,
  //           path: SUB_ITEM_URL.AUDIT_USER_ACTIVE_INACTIVE_LOG,
  //           component: UserActiveInactiveLog,
  //           exact: true,
  //           icon: faUserTie,
  //         },
  //         {
  //           name: PAGE_NAME.AUDIT_USER_LAST_LOGIN_LOG,
  //           module: PAGE_NAME.AUDIT_USER_LAST_LOGIN_LOG,
  //           path: SUB_ITEM_URL.AUDIT_USER_LAST_LOGIN_LOG,
  //           component: UserLastLoginLog,
  //           exact: true,
  //           icon: faUserTie,
  //         },
  //       ],
  //     },
  // ],
  // },
];

export default dashboardRoutes.filter((route) => {
  if (!route.collapsible) {
    return checkRoutePermission([route.module]);
  } else {
    if (route.items && route.items.length) {
      let validRoute = false;
      route.items = route.items.filter((item) => {
        let validItem = false;
        if (item.subItems && item.subItems.length) {
          item.subItems = item.subItems.filter((subItem) => {
            if (checkRoutePermission([subItem.module])) {
              validRoute = true;
              validItem = true;
              return true;
            }
          });
        }
        return validItem;
      });
      return validRoute;
    }
  }
});

// export default dashboardRoutes;
